module.exports = __webpack_public_path__ + "static/media/wmgr_watch.8dca18e2.png";